export default {
      id: "refeer__coil-usage",
      viewBox: "0 0 23 34",
      url: __webpack_public_path__ + "img/icons.svg#refeer__coil",
      toString: function () {
        return this.url;
      }
    }